import Vue from 'vue';
import App from "@/views/App.vue";
import vuetify from './plugins/vuetify';
import router from './router';
import store from "@/store";
import { VueMaskDirective, VueMaskFilter } from 'v-mask'
import VCalendar from 'v-calendar';
import Keycloak from 'keycloak-js';
import './style.css'
import './assets/styles/filters.css'
import './assets/styles/tables.css'
import './assets/styles/pagination.css'
import './assets/styles/forms.css'
import './assets/styles/action-buttons.css'

Vue.filter('VMask', VueMaskFilter)
Vue.directive('mask', VueMaskDirective);
Vue.config.productionTip = false;

Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

Vue.prototype.$globalAlert = function (message) {
  window.alert(message);
};

Vue.filter('currency', function (value) {
  if (!value) return 'R$ 0,00';
  value = parseFloat(value).toFixed(2).toString();
  // Substitui o ponto decimal por uma vírgula e adiciona pontos como separadores de milhar
  return 'R$ ' + value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
});

const keycloak = Keycloak({
  url: process.env.VUE_APP_KEYCLOAK_SERVICES,
  realm: process.env.VUE_APP_REALM,
  clientId: process.env.VUE_APP_CLIENT
});

Vue.prototype.$keycloak = keycloak;

keycloak.init({ 
  onLoad: 'login-required',
  checkLoginIframe: false,
  enableLogging: true
}).then((authenticated) => {
  if (authenticated) {

    const roles = keycloak.resourceAccess && keycloak.resourceAccess.rastro ? keycloak.resourceAccess.rastro.roles : [];
    store.commit('setRoles', roles);
    store.commit('setEmail', keycloak.tokenParsed ? keycloak.tokenParsed.email : '');
    store.commit('setName', keycloak.tokenParsed ? `${keycloak.tokenParsed.given_name || ''} ${keycloak.tokenParsed.family_name || ''}` : '');

    new Vue({
      store,
      vuetify,
      router,
      render: (h) => h(App, { props: { keycloak: keycloak } })
    }).$mount('#app');
  }
});